<div class="row">
  <div class="col">
    <mat-form-field class="mb-2" appearance="fill" style="width: 100%">
      <mat-label>{{ paragraph.label }}</mat-label>
      <input
        data-testid="notices_add_notice_input_title"
        type="text"
        matInput
        #titleField
        [formControl]="control"
        [required]="paragraph.isRequired"
        [placeholder]="paragraph.placeholder"
      />
      <mat-hint align="end">{{ titleField.value?.length || 0 }}/70</mat-hint>
      <mat-error *ngIf="control.hasError('required')"
        >{{ paragraph.label }}&nbsp;{{
          'workflow.request-document.basic-details.required-error' | translate
        }}
      </mat-error>
      <mat-error *ngIf="control.hasError('maxlength')"
        >{{ paragraph.label }}&nbsp;{{
          'workflow.request-document.basic-details.max-length-error' | translate
        }}
      </mat-error>
    </mat-form-field>
  </div>
</div>
